





































































































































import { Component, Vue, Mixins } from "vue-property-decorator";
import Loading from "@/mixins/loading";

// api
import {
  realTime,
  paySummary,
  backLogToDo,
  accountInfo,
} from "@/api/accumulate";
import images from "./data/images";

@Component
export default class ProductCallback extends Mixins(Loading) {

  todayData:Array<{
    title1: string;
    value1: string;
    title2?: string;
    value2?: string;
    classValueUp?:String;
    classValueDown?:String;

  }> = [
    {
      title1: "支付订单数量",
      value1: "0",
      value2: "10000",
      classValueUp:"data_image hide",
      classValueDown:"data_image hide",
    },
    {
      title1: "支付金额（元）",
      value1: "0.00",
      value2: "0.00",
      classValueUp:"data_image hide",
      classValueDown:"data_image hide",    },
    {
      title1: "返佣金额（元）",
      value1: "0.00",
      value2: "0.00",
      classValueUp:"data_image hide",
      classValueDown:"data_image hide",
    },
    {
      title1: "浏览量",
      value1: "0",
      value2: "0",
      classValueUp:"data_image hide",
      classValueDown:"data_image hide",
    },
    {
      title1: "访问人数",
      value1: "0",
      value2: "0",
      classValueUp:"data_image hide",
      classValueDown:"data_image hide",    },
    {
      title1: "入驻人数",
      value1: "0",
      value2: "0",
      classValueUp:"data_image hide",
      classValueDown:"data_image hide",
    },
];
   accountData:Array<{
    title1: string;
    value1: string;
    img?: string;
  }> = [
    {
      title1: "总交易金额（元）",
      value1: "￥ 0.00",
      img: images.zjyje
    },
    {
      title1: "总返佣金额（5‰）",
      value1: "￥ 0.00",
      img: images.zfyje,
    },
    {
      title1: "已提佣金（元）",
      value1: "0",
      img: images.ytyj,
    },
    {
      title1: "支付订单数量",
      value1: "0",
      img: images.zfdds,
    },
    {
      title1: "会员人数",
      value1: "0",
      img: images.vip,
    },
    {
      title1: "实际货款累计(元)",
      value1: "0.00",
      img: images.sjhk,
    },
  ];
  updateTime1:String = "";
  updateTime2:String = "";
  updateTime3:String = "";

  dealData:Array<{
    title1: string;
    value1: string;
    img?: string;
    value2?: string;
  }> = [
    {
      title1: "养生元",
      value1: "0",
      img: "",
      value2: "0",
    },
    {
      title1: "赠送金额",
      value1: "0",
      img: "",
      value2: "0",
    },
    {
      title1: "微信交易",
      value1: "0",
      img: "",
      value2: "0",
    }];

  todoData:Array<{
    title1: string;
    value1: string;
  }> = [
    {
      title1: "在架产品",
      value1: "0",

    },
    {
      title1: "待发货",
      value1: "0",

    },
    {
      title1: "售后中",
      value1: "0",

    },
    {
      title1: "待退款(元)",
      value1: "0"
    }];
  current_month_amount:Number=0;
  last_month_amount:Number=0;
  mounted() {
    this.getData();
  }

  // 获取数据
  getData() {
    this.showLoading();
    //进入概况实时数据
    let p1 = realTime().then((res: any) => {
      let { orderPayCountToDay, orderPayCountYesterday,orderPayAmountToday,orderPayAmountYesterday,rebateToday,rebateYesterday,
        uvToday,uvYesterday,pvToday,pvYesterday,enterPersonToday,enterPersonYesterday,updateTime
      } = res.data;
      this.updateTime1 = updateTime;
      this.todayData[0].value1 = orderPayCountToDay || 0;
      this.todayData[0].value2 = orderPayCountYesterday || 0;
      if(orderPayCountToDay>orderPayCountYesterday){
        this.todayData[0].classValueUp="data_image"
      }

      if(orderPayCountToDay<orderPayCountYesterday){
        this.todayData[0].classValueDown="data_image"
      }

      this.todayData[1].value1 = orderPayAmountToday || 0;
      this.todayData[1].value2 = orderPayAmountYesterday || 0;
      if(orderPayAmountToday>orderPayAmountYesterday){
        this.todayData[1].classValueUp="data_image"
      }
      if(orderPayAmountToday<orderPayAmountYesterday){
        this.todayData[1].classValueDown="data_image"
      }

      this.todayData[2].value1 = rebateToday || 0;
      this.todayData[2].value2 = rebateYesterday || 0;
      if(rebateToday>rebateYesterday){
        this.todayData[2].classValueUp="data_image"
      }
      if(rebateToday<rebateYesterday){
        this.todayData[2].classValueDown="data_image"
      }


      this.todayData[3].value1 =  pvToday || 0;
      this.todayData[3].value2 = pvYesterday || 0;

      if(pvToday>pvYesterday){
        this.todayData[3].classValueUp="data_image"
      }
      if(pvToday<pvYesterday){
        this.todayData[3].classValueDown="data_image"
      }


      this.todayData[4].value1 = uvToday|| 0;
      this.todayData[4].value2 =  uvYesterday|| 0;
      if(uvToday>uvYesterday){
        this.todayData[4].classValueUp="data_image"
      }
      if(uvToday<uvYesterday){
        this.todayData[4].classValueDown="data_image"
      }


      this.todayData[5].value1 = enterPersonToday || 0;
      this.todayData[5].value2 = enterPersonYesterday || 0;
      if(enterPersonToday>enterPersonYesterday){
        this.todayData[5].classValueUp="data_image"
      }
      if(enterPersonToday<enterPersonYesterday){
        this.todayData[5].classValueDown="data_image"
      }

    });

    let p2 = paySummary().then((res: any) => {
      console.log(res.data)

      let { transactionAmountCurrentMonth,transactionAmountLastMonth,balanceCurrentMonth,balanceLastMonth,
        balanceGiveCurrentMonth,balanceGiveLastMonth,weiXinCurrentMonth,weiXinLastMonth,updateTime} = res.data;
      this.updateTime2 = updateTime;

      this.dealData[0].value1=balanceCurrentMonth;
      this.dealData[0].value2= balanceLastMonth;
      if(balanceCurrentMonth>balanceLastMonth){
        this.dealData[0].img = images.up;
      }
      else  if(balanceCurrentMonth<balanceLastMonth){
        this.dealData[0].img = images.down;
      }
      else{
        this.dealData[0].img = "";
      }
      this.dealData[1].value1=balanceGiveCurrentMonth;
      this.dealData[1].value2= balanceGiveLastMonth;
      if(balanceGiveCurrentMonth>balanceGiveLastMonth){
        this.dealData[1].img = images.up;
      }
      else  if(balanceGiveCurrentMonth<balanceGiveLastMonth){
        this.dealData[1].img = images.down;
      }else{
        this.dealData[1].img = "";
      }
      this.dealData[2].value1=weiXinCurrentMonth;
      this.dealData[2].value2= weiXinLastMonth;
      if(weiXinCurrentMonth>weiXinLastMonth){
        this.dealData[2].img = images.up;
      }
      else if(weiXinCurrentMonth<weiXinLastMonth){
        this.dealData[2].img = images.down;
      }
      else{
        this.dealData[2].img = "";
      }

      this.current_month_amount=transactionAmountCurrentMonth;
      this.last_month_amount = transactionAmountLastMonth;

      // this.list[0].value1 = "￥ " + (sumCost || 0);
      // this.list[0].value2 = "￥ " + (dayAvgCost || 0);
    });
    let p3 = backLogToDo().then((res: any) => {
      let { productCount, awaitSend,afterSaleCount,afterSaleCountAmount } = res.data;

      this.todoData[0].value1 = productCount || 0;
      this.todoData[1].value1 = awaitSend || 0;
      this.todoData[2].value1 = afterSaleCount || 0;
      this.todoData[3].value1 = afterSaleCountAmount || 0 ;


    });
    let p4 = accountInfo().then((res: any) => {
      let {orderSumAmount,sumRebateCost,withdrawApplyAmount,payCount,enterCustomerCount,actualMoney,updateTime  } = res.data;
      this.updateTime3 = updateTime;

       this.accountData[0].value1= orderSumAmount || 0;
      this.accountData[1].value1= sumRebateCost || 0;
      this.accountData[2].value1= withdrawApplyAmount || 0;
      this.accountData[3].value1= payCount || 0;
      this.accountData[4].value1= enterCustomerCount || 0;
      this.accountData[5].value1= actualMoney || 0;

      // this.list[3].value2 = dayAvgEnterCustomer;
    });

    Promise.all([p1, p2, p3, p4]).then((res: any) => {
      this.hideLoading();
    });
  }
  redirect(item:any){
    if(item.title1=="待退款(元)"){
      this.GoToReturnOrder();
    }else if(item.title1=="售后中"){
      this.GoToAfterSale();
    }

  }
  GoToReturnOrder() {
    this.$router.push({
      path: "/afterSale",

    });
  }
  GoToAfterSale() {
    this.$router.push({
      path: "/order",
      query: { orderStatus:"12" }

    });
  }
}
